import StrategiesAPI from 'dashboard/api/strategies';

const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
};

const getters = {
  getStrategies: _state => _state.records,
  getUIFlags: _state => _state.uiFlags,
  getStrategyById: _state => id => _state.records.find(s => s.id === Number(id)),
};

const mutations = {
  SET_STRATEGIES(_state, strategies) {
    _state.records = strategies;
  },
  ADD_STRATEGY(_state, strategy) {
    _state.records.unshift(strategy);
  },
  UPDATE_STRATEGY(_state, strategy) {
    const index = _state.records.findIndex(s => s.id === strategy.id);
    if (index !== -1) {
      _state.records.splice(index, 1, strategy);
    }
  },
  DELETE_STRATEGY(_state, id) {
    _state.records = _state.records.filter(s => s.id !== id);
  },
  SET_UI_FLAG(_state, { key, value }) {
    _state.uiFlags[key] = value;
  },
};

const actions = {
  async fetchStrategies({ commit }) {
    commit('SET_UI_FLAG', { key: 'isFetching', value: true });
    try {
      const { data } = await StrategiesAPI.get();
      commit('SET_STRATEGIES', data);
      return data;
    } catch (error) {
      throw error;
    } finally {
      commit('SET_UI_FLAG', { key: 'isFetching', value: false });
    }
  },

  async createStrategy({ commit }, strategyData) {
    commit('SET_UI_FLAG', { key: 'isCreating', value: true });
    try {
      const { data } = await StrategiesAPI.create(strategyData);
      commit('ADD_STRATEGY', data);
      return data;
    } catch (error) {
      throw error;
    } finally {
      commit('SET_UI_FLAG', { key: 'isCreating', value: false });
    }
  },

  async updateStrategy({ commit }, { id, ...strategyData }) {
    commit('SET_UI_FLAG', { key: 'isUpdating', value: true });
    try {
      const { data } = await StrategiesAPI.update(id, strategyData);
      commit('UPDATE_STRATEGY', data);
      return data;
    } catch (error) {
      throw error;
    } finally {
      commit('SET_UI_FLAG', { key: 'isUpdating', value: false });
    }
  },

  async deleteStrategy({ commit }, id) {
    commit('SET_UI_FLAG', { key: 'isDeleting', value: true });
    try {
      await StrategiesAPI.delete(id);
      commit('DELETE_STRATEGY', id);
    } catch (error) {
      throw error;
    } finally {
      commit('SET_UI_FLAG', { key: 'isDeleting', value: false });
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
